import './Page.css';

function About() {
  return (
    <main className="page">
      <h1>About Positive</h1>
      <div className="content-container">
        <section className="content-section">
          <h2>What is Positive Affect Journaling?</h2>
          <p>
            Positive Affect Journaling is a relatively new take on journaling.
            While gratitude journaling focuses on what you're thankful for, positive affect
            journaling uses a fresh selection of thoughtful prompts each day to spark recollection and guide your
            reflections.             
          </p>
        </section>

        <section className="content-section">
          <h2>Why Do Positive Affect Journaling</h2>
          <div className="benefit-card center">
            <h3>Engaging</h3>
            <p>
              The variety of daily prompts keeps the practice fresh and interesting.
              Unlike repeating the same gratitude questions, each day brings new topics
              to explore, making it easier to build a sustainable journaling habit.
            </p>
          </div>
          <div className="benefit-card center">
            <h3>Deep Reflections</h3>
            <p>
              The prompts aren't limited to what happened today. They invite you to
              reflect on memories, aspirations, relationships, and personal growth.
            </p>
          </div>
          <div className="benefit-card center">
            <h3>Overcome Blank Page Syndrome</h3>
            <p>
              Staring at a blank page can be intimidating. These daily prompts give you
              a starting point, making it easy to begin writing and discover thoughts
              you didn't know you had.
            </p>
          </div>
        </section>

        <section className="content-section">
          <h2>The Science Behind It</h2>
          <p>
            Research shows that regular reflective writing can improve mood, reduce
            anxiety, and enhance overall well-being. 
            Participants in initial studies performing Positive Affect Journaling reported less depressive symptoms and anxiety after the first month and greater resilience after two months.
          </p>
          <p>
            That said, I'm not a medical professional and this site isn't a replacement for therapy.
            If you're struggling with mental health, please consider reaching out to a qualified professional.
          </p>
        </section>
      </div>
    </main>
  );
}

export default About;
